<div class="EditContainer">
  <div class="row">
    <div class="col">
      <label for="urlExpression">Url</label>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">/Backend/Report/</span>
          </div>
        <input type="text" class="form-control" id="urlExpression" [(ngModel)]="Route.urlExpression">
        </div>
    </div>
  </div>
  @if(!IsNew())
  {
  <div class="row">
    <div class="col">
      <div class="DataList mb-3">
      @for(entry of FunctionsList(); track entry.functionName)
      {
        <div class="Entry">
          <div class="EntryHeader">
            {{entry.functionName}}
          </div>
          <div class="ItemHeader row">
            <div class="col">Parameter</div>
            <div class="col">Url Part</div>
            <div class="col">Default Value</div>
          </div>
          @for (item of entry.parameters; track item.parameter)
          {
            <div class="Item row">
              <div class="col">{{ item.parameter }}</div>
              <div class="col">
                  <input type="text" class="form-control"
                         [ngModel]="LoadUrlPart(item)"
                         (ngModelChange)="ChangeUrlPart($event,item)">
              </div>
              <div class="col">
                <input type="text" class="form-control"
                       [ngModel]="LoadDefaultValue(item)"
                       (ngModelChange)="ChangeDefaultValue($event,item)">
              </div>
            </div>
          }
        </div>
      }
      </div>
    </div>
  </div>
  }
</div>
<div class="row Button">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="SaveData()">Speichern</div>
  </div>
</div>
